<infra-charge [infraCharge]="otpSession?.infraChargeDto" [ghostMode]="ghostMode"></infra-charge>
<ion-card>
    <ion-card-content [hidden]="remoteRequest">
        <ion-label class="ion-text-center">
            <div class="passWrapper">
                <div class="passContainer">
                    <p class="passContainer-title"><span class="ghost-hidden">{{'otp.code' | translate}}</span></p>
                    <p class="passContainer-number">{{otpSession?.otpCode}}</p>
                </div>

                <p class="passInfo">
                <span class="ghost-hidden">
                    * {{'otp.until' | translate: {expirationDate: otpSession?.expirationDate | date:'medium'} }}
                </span>
                </p>

            </div>

            <div class="passPrice">
                <p>
                    <span class="ghost-hidden">{{'otp.pricing' | translate}}</span>
                </p>
                <div class="passPrice-price ghost-hidden">
                    <pricing-context-formatter [pricingContext]="otpSession?.pricingContext"
                                               class="large-ghost-size">
                    </pricing-context-formatter>
                </div>
            </div>
        </ion-label>
        <ion-button color="secondary" expand="block"
                    [hidden]="!canShowRemoteStart"
                    (click)="showRemoteStart()">
            {{'otp.remoteStart' | translate}}
        </ion-button>
        <p class="passWrapper" [hidden]="otpSession?.remoteStart || ghostMode">{{'otp.manual.start' | translate}}</p>
    </ion-card-content>
    <remote [hidden]="!remoteRequest"
            [action]="Action.START"
            [request]="remoteRequest"
            (remoteResponse)="handleRemoteResponse($event)"></remote>
</ion-card>
